export default __webpack_public_path__ + "static/media/ad_5.46d80af9.mp3";